import { useIonRouter, IonFooter, IonLoading, IonText, IonCard, IonGrid, IonContent, IonButton, IonButtons, IonToolbar, IonModal, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow } from '@ionic/react';
import { logoGoogle, walletOutline, closeOutline } from 'ionicons/icons';
import React, { useState, Component, useEffect }  from 'react';

import { LANGUAGE, GetStr } from "../language/Language";
import NServer, { handleRouteError, RegisterAppServices } from "../components/NServer";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';
import ChatComp from '../components/ChatComp';
import ChatInput from "../components/ChatInput";

import '../pages/Main.css';
import '../pages/ChatMsg.css';


interface ChatDlgProp {
    show : boolean,
    dismiss : any,
    thread : number,
    timer : number,
    updateChat : any
}
  
const ChatDialog : React.FC<ChatDlgProp> = ({ show, dismiss, thread, timer, updateChat }) => {

    const [repliedMsg, setRepliedMsg] = useState<any>(null);
    const [needJoin, setNeedJoin] = useState(false);
    const [blocked, setBlocked] = useState(false);
    const [maxImages, setMaxImages] = useState(0);
    const [totalImages, setTotalImages] = useState(0);
    const [minWords, setMinWords] = useState(0);
    const [email, setEmail] = useState("");
    const [chatType, setChatType] = useState("");
    const [closed, setClosed] = useState(false);
    const [avatar, setAvatar] = useState("https://nwallet.me/img/avt.jpg");
    const [userID, setUserID] = useState(-1);
    const [name, setName] = useState("User");
    const [threadID, setThreadID] = useState(-1);
    const [needLogin, setNeedLogin] = useState(false);

    const router = useIonRouter();

    // need to refresh
    useEffect(() => {
        // init
        checkLogin();
    }, [thread]);

    // check the login
    const checkLogin = async () => {
         let v = new Vault();
        await v.read();

        if (v.account.id < 20)
            setNeedLogin(true);
        else
            setNeedLogin(false);
    }

    // set the server data
    const setServer = (server : any) => {
        checkLogin();

        setUserID(server.data.user);
        setAvatar(server.data.avatar);
        setName(server.data.title);
        setThreadID(server.data.thread);
        setBlocked(server.data.blocked == 1);
        setChatType(server.data.chat_type);

        setClosed(server.data.closed == 1);
        setMaxImages(server.data.max_img);
        setTotalImages(server.data.total_img);
        setMinWords(server.data.min_words);
        setNeedJoin(server.data.need_join == 1);
    }

    // do the login
    const doLogin = () => {
        dismiss();
        router.push("/login", "back", "pop");
    }

    return (
        <IonModal
            isOpen={show}
            initialBreakpoint={ 1 }
            onDidDismiss={dismiss}
        >
            <div className="ion-page">
                <IonToolbar id="modal">
                    <IonItem lines="none">
                        <IonAvatar slot="start">
                            <img src={avatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
                        </IonAvatar>
                        <IonLabel>
                            {name}
                        </IonLabel>
                    </IonItem>
                    <IonButtons slot="end">
                        <IonButton onClick={dismiss}>
                            <IonIcon icon={closeOutline} size="large"/>
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
                <IonContent>
                    <ChatComp 
                        id={thread}
                        type="thread"
                        bk=""
                        timer={timer}
                        setServer={setServer}
                        setRepliedMsg={setRepliedMsg}
                    />
                </IonContent>
                <div className="chat-dlg-footer">
                    {
                        needLogin ?
                    <div className="bk-panel">
                        <IonButton className="main-but ion-margin" color="primary" expand="block" onClick={doLogin}>
                            <IonIcon icon={logoGoogle} />&nbsp;&nbsp;
                            { GetStr(LANGUAGE.TXT_GOOGLE_LOGIN) }
                        </IonButton>
                    </div>
                        :
                    <ChatInput 
                        id={thread} type="thread"
                        thread={threadID} need_join={needJoin} 
                        replied_msg={repliedMsg}
                        block={blocked}
                        max_images={maxImages}
                        total_images={totalImages}
                        minWords={minWords} 
                        email={email}
                        updateChat={updateChat}
                        chatType={chatType} 
                        closed={closed}
                    >
                    </ChatInput>
                    }
                </div>
            </div>
        </IonModal>
    );
};
  
export default ChatDialog;